/* ============================================================
   Adam Star — shared theme behaviour
   Currency dropdown · mega menu · sticky header · mobile drawer ·
   newsletter popup · cart drawer · free-gift sync.
   Currency & language are real Shopify `localization` forms
   (server-rendered), so this file only handles UI open/close.
   ============================================================ */
(function () {
  "use strict";

  /* ---- Header currency dropdown (localization form) ---- */
  function initCurrency() {
    var curr = document.getElementById("currency");
    if (!curr) return;
    var currBtn = document.getElementById("currency-btn");
    if (!currBtn) return;
    currBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      var open = curr.classList.toggle("open");
      currBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("click", function () {
      curr.classList.remove("open");
      currBtn.setAttribute("aria-expanded", "false");
    });
  }

  /* ---- Mega menu (hover) ----
     Three things govern how this feels:

     1. Hover intent. Opening on the very first mouseenter meant panels flashed
        open while the pointer merely swept across the nav on its way elsewhere.
        A short delay before the FIRST panel opens absorbs that. Once a panel is
        already showing there is no delay at all — moving along the row should
        track the pointer exactly.

     2. Close grace. Travelling from a nav link down into the panel crosses a
        few pixels of bare header that belong to neither, which fires mouseleave.
        140ms was tight enough to lose the panel on a slow or diagonal move.

     3. Swap vs. entrance. Opening a second panel while one is up used to replay
        the full staggered entrance, so the menu appeared to lag behind the
        pointer. `mega-swap` marks that case and the CSS collapses the animation
        to a quick crossfade. */
  function initMega() {
    var navRow = document.getElementById("nav-row");
    var megaWrap = document.getElementById("mega-wrap");
    if (!navRow || !megaWrap) return;
    var closeTimer = null, openTimer = null, current = null;

    function apply(id) {
      megaWrap.classList.toggle("mega-swap", current !== null && current !== id);
      current = id;
      Array.prototype.forEach.call(navRow.querySelectorAll(".nav-item"), function (n) {
        n.classList.toggle("active", n.getAttribute("data-mega") === id);
      });
      Array.prototype.forEach.call(megaWrap.querySelectorAll(".mega"), function (m) {
        m.classList.toggle("open", m.getAttribute("data-mega") === id);
      });
      document.body.classList.add("menu-open");
    }

    function open(id) {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      if (current === id) return;
      var wait = current === null ? 90 : 0;
      if (wait === 0) { apply(id); return; }
      openTimer = setTimeout(function () { apply(id); }, wait);
    }

    function closeNow() {
      current = null;
      megaWrap.classList.remove("mega-swap");
      Array.prototype.forEach.call(navRow.querySelectorAll(".nav-item"), function (n) { n.classList.remove("active"); });
      Array.prototype.forEach.call(megaWrap.querySelectorAll(".mega"), function (m) { m.classList.remove("open"); });
      document.body.classList.remove("menu-open");
    }

    function closeSoon() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeNow, 220);
    }

    Array.prototype.forEach.call(navRow.querySelectorAll(".nav-item"), function (n) {
      var id = n.getAttribute("data-mega");
      var hasMega = id && megaWrap.querySelector('.mega[data-mega="' + id + '"]');
      n.addEventListener("mouseenter", function () { hasMega ? open(id) : closeSoon(); });
      n.addEventListener("mouseleave", closeSoon);
    });
    megaWrap.addEventListener("mouseenter", function () { clearTimeout(closeTimer); });
    megaWrap.addEventListener("mouseleave", closeSoon);
    /* Keyboard and touch users get out the same way as everyone else. */
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeNow(); });
  }

  /* ---- Scrolled state ----
     Runs on EVERY page, not just the home overlay. On home it swaps the
     transparent hero header for the solid one; everywhere else it only adds a
     shadow once the page has moved. The early return that used to sit here
     meant `scrolled` was never applied outside the home page. */
  function initStickyHeader() {
    var last = false;
    function update() {
      var scrolled = window.scrollY > 80;
      if (scrolled !== last) { document.body.classList.toggle("scrolled", scrolled); last = scrolled; }
    }
    window.addEventListener("scroll", update, { passive: true });
    update();
  }

  /* ---- Mobile nav drawer ---- */
  function initDrawer() {
    var nd = document.getElementById("nd");
    var bd = document.getElementById("nd-backdrop");
    var hb = document.getElementById("hamburger");
    var cl = document.getElementById("nd-close");
    if (!nd || !hb) return;
    function closePanels() {
      Array.prototype.forEach.call(document.querySelectorAll(".nd-panel.open"), function (p) {
        p.classList.remove("open");
        p.setAttribute("aria-hidden", "true");
      });
    }
    function open() { nd.classList.add("open"); bd.classList.add("open"); nd.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; }
    function close() { closePanels(); nd.classList.remove("open"); bd.classList.remove("open"); nd.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }
    hb.addEventListener("click", open);
    if (cl) cl.addEventListener("click", close);
    if (bd) bd.addEventListener("click", close);
    Array.prototype.forEach.call(nd.querySelectorAll(".nd-item[data-accordion] > .nd-row"), function (row) {
      row.addEventListener("click", function () { row.closest(".nd-item").classList.toggle("open"); });
    });

    /* Second-level slide panels */
    Array.prototype.forEach.call(document.querySelectorAll("[data-panel-open]"), function (btn) {
      btn.addEventListener("click", function () {
        var p = document.getElementById(btn.getAttribute("data-panel-open"));
        if (p) { p.classList.add("open"); p.setAttribute("aria-hidden", "false"); }
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-panel-back]"), function (btn) {
      btn.addEventListener("click", function () {
        var p = btn.closest(".nd-panel");
        if (p) { p.classList.remove("open"); p.setAttribute("aria-hidden", "true"); }
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll("[data-panel-close-all]"), function (btn) {
      btn.addEventListener("click", close);
    });
  }

  /* ---- Newsletter popup ---- */
  function initNewsletterPopup() {
    var backdrop = document.getElementById("nl-pop-backdrop");
    if (!backdrop) return;
    var KEY = "as_newsletter_seen";
    var delay = parseInt(backdrop.getAttribute("data-delay") || "5000", 10);
    function dismiss() { backdrop.classList.remove("open"); try { sessionStorage.setItem(KEY, "1"); } catch (e) {} }
    var seen = false;
    try { seen = sessionStorage.getItem(KEY) === "1"; } catch (e) {}
    if (!seen) { setTimeout(function () { backdrop.classList.add("open"); }, delay); }
    var closeBtn = document.getElementById("nl-close");
    if (closeBtn) closeBtn.addEventListener("click", dismiss);
    backdrop.addEventListener("click", function (e) { if (e.target === backdrop) dismiss(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && backdrop.classList.contains("open")) dismiss(); });
  }

  /* ---- Cart drawer (Ajax cart, re-rendered via the Section Rendering API) ---- */
  function initCartDrawer() {
    var root = document.getElementById("cart-drawer-root");
    if (!root) return;
    var routes = window.themeRoutes || { root: "/", cartAdd: "/cart/add", cartChange: "/cart/change", cartUpdate: "/cart/update" };
    /* data-cart-open is the stable hook; the aria-label match is kept as a
       fallback so the drawer still opens if markup elsewhere lags behind. */
    var BAG_SELECTOR = '[data-cart-open], a[aria-label="Bag"]';

    function openCart() {
      /* close the mobile nav drawer if it's open */
      var nd = document.getElementById("nd"), ndBd = document.getElementById("nd-backdrop");
      if (nd) { nd.classList.remove("open"); nd.setAttribute("aria-hidden", "true"); }
      if (ndBd) ndBd.classList.remove("open");
      Array.prototype.forEach.call(document.querySelectorAll(".nd-panel.open"), function (p) { p.classList.remove("open"); });
      document.body.classList.add("cartd-open");
      document.body.style.overflow = "hidden";
    }
    function closeCart() {
      document.body.classList.remove("cartd-open");
      document.body.style.overflow = "";
    }

    /* The drawer lives in the footer section group, so its section id is "sections--…__cart-drawer".
       Requesting the bare "cart-drawer" renders a default instance WITHOUT the saved settings
       (gift product, labels), so resolve the real instance id from the wrapping .shopify-section. */
    function sectionId() {
      var wrap = root.closest(".shopify-section");
      return wrap && wrap.id ? wrap.id.replace("shopify-section-", "") : "cart-drawer";
    }

    function postJSON(url, payload) {
      return fetch(url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(payload)
      });
    }

    /* ---- Free gift sync -------------------------------------------------
       Shopify only applies a "Buy X get Y" discount to an item that is already
       IN the cart, so the theme has to put it there. Every number here is
       computed server-side in the section and re-read after each render — the
       client never decides eligibility on its own, which keeps this in step
       with the discount instead of guessing alongside it.

       Loop safety matters more than anything else in this function: it reacts
       to a cart change by causing a cart change. `giftBusy` blocks re-entry
       while a request is in flight, and `giftTries` caps the number of
       corrections per interaction so a mismatch that cannot be resolved (a
       sold-out gift, a rejected add) fails quietly instead of hammering the
       Ajax API. */
    var giftBusy = false;
    var giftTries = 0;
    var GIFT_MAX_TRIES = 3;

    function giftConfig() {
      var el = root.querySelector("[data-gift-gate]");
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }
    function giftDeclineKey(id) { return "as_gift_declined_" + id; }
    function giftDeclined(cfg) {
      if (!cfg.allowDecline) return false;
      try { return sessionStorage.getItem(giftDeclineKey(cfg.variantId)) === "1"; } catch (e) { return false; }
    }

    /* Returns a promise resolving true when a correction was made — the caller
       then re-renders so the drawer reflects the new cart. */
    function syncGift() {
      if (giftBusy) return Promise.resolve(false);
      var cfg = giftConfig();
      if (!cfg || !cfg.enabled || !cfg.variantId || !cfg.threshold) return Promise.resolve(false);

      var want = (cfg.eligible >= cfg.threshold && !giftDeclined(cfg)) ? 1 : 0;
      if (cfg.inCart === want) { giftTries = 0; return Promise.resolve(false); }
      if (giftTries >= GIFT_MAX_TRIES) return Promise.resolve(false);

      giftBusy = true;
      giftTries++;

      var req;
      if (want === 1 && cfg.inCart === 0) {
        req = postJSON(routes.cartAdd, { id: cfg.variantId, quantity: 1 });
      } else {
        /* Covers both removal (0) and trimming an over-quantity gift back to 1.
           Keyed by variant id rather than line number so it stays correct
           however the cart has been reordered. */
        var updates = {};
        updates[cfg.variantId] = want;
        req = postJSON(routes.cartUpdate, { updates: updates });
      }

      return req
        .then(function (r) { return r.ok; })
        .catch(function () { return false; })
        .then(function (ok) { giftBusy = false; return ok; });
    }

    function refresh(openAfter) {
      var sid = sectionId();
      return fetch(routes.root + "?sections=" + encodeURIComponent(sid))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[sid] || data["cart-drawer"];
          if (!html) return;
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var next = tmp.querySelector("#cart-drawer-root");
          var cur = document.getElementById("cart-drawer-root");
          if (next && cur) cur.innerHTML = next.innerHTML;
          /* sync header bag badge */
          var count = next ? parseInt(next.getAttribute("data-cart-count") || "0", 10) : 0;
          if (cur && next) cur.setAttribute("data-cart-count", String(count));
          Array.prototype.forEach.call(document.querySelectorAll(BAG_SELECTOR), function (bag) {
            var badge = bag.querySelector(".badge");
            if (count > 0) {
              if (!badge) { badge = document.createElement("span"); badge.className = "badge"; bag.appendChild(badge); }
              badge.textContent = count;
            } else if (badge) { badge.remove(); }
          });
          if (openAfter) openCart();

          /* The freshly rendered section carries new gift numbers; act on them,
             then render once more so the drawer shows the corrected cart. */
          return syncGift().then(function (changed) {
            if (changed) return refresh(false);
          });
        });
    }

    /* Quick add (Oct 2026) adds through the Ajax API itself, then asks the drawer to re-render and
   open. A fresh interaction, so the free-gift correction counter starts again. */
window.AdamCart = {
open: openCart,
refresh: refresh,
added: function () { giftTries = 0; return refresh(true); }
};

/* Open on bag icon click instead of navigating to /cart */
    document.addEventListener("click", function (e) {
      var bag = e.target.closest(BAG_SELECTOR);
      if (bag) { e.preventDefault(); openCart(); return; }
      if (e.target.closest("[data-cartd-close]")) { closeCart(); return; }

      var qtyBtn = e.target.closest("[data-cartd-qty]");
      if (qtyBtn) {
        var line = parseInt(qtyBtn.getAttribute("data-line"), 10);
        var current = parseInt(qtyBtn.getAttribute("data-quantity") || "1", 10);
        var mode = qtyBtn.getAttribute("data-cartd-qty");
        var qty = mode === "plus" ? current + 1 : mode === "minus" ? current - 1 : 0;
        if (qty < 0) qty = 0;
        qtyBtn.disabled = true;
        /* A quantity change can cross the gift threshold in either direction,
           so reset the attempt counter — this is a fresh interaction. */
        giftTries = 0;
        postJSON(routes.cartChange, { line: line, quantity: qty }).then(function () { refresh(false); });
        return;
      }

      var recAdd = e.target.closest("[data-cartd-add]");
      if (recAdd) {
        recAdd.disabled = true;
        giftTries = 0;
        postJSON(routes.cartAdd, { id: parseInt(recAdd.getAttribute("data-cartd-add"), 10), quantity: 1 })
          .then(function () { refresh(false); });
        return;
      }
    });

    /* Gift message = paid add-on: tick adds the gift product, untick removes it.
       Removal goes through cart/update's `updates` map keyed by variant id — the most
       reliable way to zero a line regardless of its position or properties. */
    document.addEventListener("change", function (e) {
      if (e.target.matches("[data-cartd-gift]")) {
        var cb = e.target;
        var gid = parseInt(cb.getAttribute("data-gift-id"), 10);
        if (!gid) return;
        cb.disabled = true;
        giftTries = 0;
        var payload;
        var req;
        if (cb.checked) {
          req = postJSON(routes.cartAdd, { id: gid, quantity: 1 });
        } else {
          payload = { updates: {} };
          payload.updates[gid] = 0;
          req = postJSON(routes.cartUpdate, payload);
        }
        req.then(function () { refresh(false); });
      }
    });

    /* Intercept product add-to-cart forms: add via Ajax, then open the drawer */
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute("action") && form.getAttribute("action").indexOf("/cart/add") !== -1) {
        e.preventDefault();
        var btn = form.querySelector("[data-atc]");
        if (btn) btn.disabled = true;
        giftTries = 0;
        fetch(routes.cartAdd + ".js", { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (btn) btn.disabled = false;
            if (res && res.status && res.status !== 200) { alert(res.description || "Could not add to cart."); return; }
            refresh(true);
          })
          .catch(function () { if (btn) btn.disabled = false; form.submit(); });
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && document.body.classList.contains("cartd-open")) closeCart();
    });

    /* Remember an explicit decline so the gift is not forced back — only when
       the merchant has allowed declining. The drawer hides the gift's own
       remove control, so this fires from the /cart page. */
    document.addEventListener("click", function (e) {
      var el = e.target.closest("[data-gift-decline]");
      if (!el) return;
      var cfg = giftConfig();
      if (!cfg || !cfg.allowDecline) return;
      try { sessionStorage.setItem(giftDeclineKey(cfg.variantId), "1"); } catch (err) {}
    });

    /* First pass on page load. On the cart page the markup is server-rendered
       and will not pick up a correction on its own, so reload once instead of
       re-rendering the drawer behind it. */
    var onCartPage = document.body.classList.contains("template-cart");
    syncGift().then(function (changed) {
      if (!changed) return;
      if (onCartPage) { window.location.reload(); return; }
      refresh(false);
    });
  }

  function init() {
    initCurrency();
    initMega();
    initStickyHeader();
    initDrawer();
    initNewsletterPopup();
    initCartDrawer();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
